package com.loyola.acessoescola.ui.registered

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

@Composable
actual fun Authorizer(
    imageUrl: String,
    deleteRecord: () -> Unit,
    fullName: String,
    navToEditRecord: () -> Unit,
    bound: String
) {
    Row {
        Spacer(modifier = Modifier.weight(0.5f))

        CommonMainAuthorizer(
            imageUrl = imageUrl,
            deleteRecord = deleteRecord,
            fullName = fullName,
            navToEditRecord = navToEditRecord,
            bound = bound,
            modifier = Modifier.fillMaxWidth()
                .padding(vertical = 4.dp)
        )
        Spacer(modifier = Modifier.weight(0.5f))
    }
}
